import * as type from '@/utvStore/store/mutation-types'
import getAuthHost from '@/utils/getAuthHost'
const authServer = getAuthHost()

const state = {
  profile: {},
  subscription: {},
  user: {},
  user_point: {},
  payment_history: [],
  friend_list: []
}

const actions = {
  [type.GET_ACCOUNT]({ commit }, access_token) {
    return axios.post(`${authServer}/api/user/info`, { access_token }).then(
      res => {
        const profile = res.data.user.profile
        Object.assign(profile, {
          response: res.data.response,
          nickname: res.data.user.nickname,
          email: res.data.user.email
        })
        if (res.data.user.relation.length > 0)
          Object.assign(profile, {
            relation: {
              id: res.data.user.relation[0].id,
              name: res.data.user.relation[0].sns_name
            }
          })
        commit(type.GET_USER_INFO, res.data.user)
        commit(type.GET_ACCOUNT, profile)
        commit(type.GET_SUBSCRIPTION_INFO, res.data.user.subscription)
        return Promise.resolve(res.data.user)
      },
      error => {
        throw new Error(error)
      }
    )
  },
  [type.GET_USER_PAYMENT_HISTORY]({ commit, state }, data) {
    return axios
      .post(
        `${authServer}/api/point/payment_history`,
        {},
        {
          params: {
            uid: data.uid
          }
        }
      )
      .then(
        res => {
          commit(type.GET_USER_PAYMENT_HISTORY, res.data.history)
        },
        error => {
          commit(type.GET_USER_PAYMENT_HISTORY, [{ error: error }])
          throw new Error(error)
        }
      )
  },
  [type.RESET_ACCOUNT]({ commit }) {
    commit(type.RESET_ACCOUNT)
  },
  [type.TARGET_FRIEND]({ commit }, data) {
    return axios.post(`${authServer}/api/friend/target`, { friend_id: data.friendId, access_token: data.token }).then(
      res => {
        commit(type.GET_FRIEND_LIST, res.data.friends)
        return res.data.friends
      },
      error => {
        commit(type.GET_FRIEND_LIST, [{ error: error }])
        throw new Error(error)
      }
    )
  },
  [type.DELETE_FRIEND]({ commit }, data) {
    return axios.post(`${authServer}/api/friend/delete`, { 'friend_id[]': data.friendIdList, access_token: data.token }).then(
      res => {
        commit(type.GET_FRIEND_LIST, res.data.friends)
        return res.data.friends
      },
      error => {
        commit(type.GET_FRIEND_LIST, [{ error: error }])
        throw new Error(error)
      }
    )
  }
}

const mutations = {
  [type.GET_USER_INFO](_state, user) {
    Object.assign(_state, { user })
  },
  [type.GET_ACCOUNT](_state, profile) {
    Object.assign(_state, { profile })
  },
  [type.RESET_ACCOUNT](_state) {
    Object.assign(_state, { profile: {} })
  },
  [type.GET_SUBSCRIPTION_INFO](_state, subscription) {
    Object.assign(_state, { subscription })
  },
  [type.GET_USER_PAYMENT_HISTORY](_state, historyList) {
    Object.assign(_state, { payment_history: historyList })
  },
  [type.GET_FRIEND_LIST](_state, friendList) {
    Object.assign(_state, { friend_list: friendList })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/store/modules/account.js